import _ from 'lodash';

const SPLIT_VALUE_BY_LEGACY_ATTRIBUTE = {
    campaign_id_attr: 'campaign_id',
    ad_id_attr: 'ad_id',
    creative_id_attr: 'markup_id',
    audience_segment_id_attr: 'audience_id',
    organization_id_attr: 'camp_org',
};

const NESTED_CREATIVE_SPLIT_VALUES = ['creative_channel', 'creative_size'];

export function normalizeV4DimensionValue(value) {
    if (!_.isString(value)) {
        return value;
    }

    if (SPLIT_VALUE_BY_LEGACY_ATTRIBUTE[value]) {
        return SPLIT_VALUE_BY_LEGACY_ATTRIBUTE[value];
    }

    return value.endsWith('_attr') ? value.slice(0, -'_attr'.length) : value;
}

export function normalizeV4Dimensions(values = []) {
    return _.uniq(_.map(values, normalizeV4DimensionValue));
}

export function normalizeV4AttributeOptions(options) {
    return _.map(options, option => ({
        ...option,
        legacyValue: option.value,
        value: normalizeV4DimensionValue(option.value),
    }));
}

export function filterV4TopLevelDimensionOptions(options) {
    return _.filter(options, option => !_.includes(NESTED_CREATIVE_SPLIT_VALUES, option.value));
}
